<template>
  <section>
    <SearchHeader />
    <SearchSearch />
    <SearchIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Search',
  components: { ...partials }
}
</script>
